/*
 * Dropzone z podgladem dla pola zdjecia OwnPrint.
 *
 * To jest progresywne wzbogacenie, nie podmiana. Pole file nalezy do bloku
 * aplikacji OwnPrint - nie mamy jego markupu i nie wolno nam go odpiac od
 * formularza: neckle-product.js przechwytuje submit i przekazuje FormData
 * z prawdziwym inputem pliku. Dlatego oryginalny input zostaje dokladnie
 * tam, gdzie byl; jest tylko wizualnie ukryty, a my rysujemy warstwe obok.
 *
 * Kazda zmiana pliku - z klikniecia, z upuszczenia, z klawiatury - konczy sie
 * natywnym zdarzeniem 'change' na oryginalnym inpucie, wiec handler OwnPrint
 * dostaje dokladnie to, czego oczekuje.
 */
(() => {
  // Uwaga: NIE [data-ownprint-slot] (to nasz kontener na app block, dostaje
  // tylko <style> OwnPrint). Prawdziwy formularz OwnPrint wstrzykuje jako
  // rodzenstwo gdzies w buy-boxie, oznaczone przez [data-ownprint-personalization]
  // - to samo zrodlo prawdy, ktorego uzywa juz neckle-ownprint-bridge.js.
  const slot = document.querySelector('[data-ownprint-personalization]');
  if (!slot) return;

  const i18nNode = document.querySelector('[data-neckle-product-i18n]');
  let i18n = {};
  try { i18n = i18nNode ? JSON.parse(i18nNode.textContent) : {}; } catch (error) { i18n = {}; }
  const tekst = (key, fallback) => i18n[key] || fallback;
  const wstaw = (template, token, value) => template.replace(token, value);

  const MAX_PODGLAD_BAJTY = 20 * 1024 * 1024;
  const MIN_KRAWEDZ_PX = 1000;

  const formatujRozmiar = (bajty) => {
    if (bajty < 1024) return bajty + ' B';
    if (bajty < 1024 * 1024) return Math.round(bajty / 1024) + ' KB';
    return (bajty / (1024 * 1024)).toLocaleString(document.documentElement.lang || 'pl-PL', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }) + ' MB';
  };

  const zbudujDropzone = (input) => {
    if (input.dataset.neckleDropzone) return;
    input.dataset.neckleDropzone = 'true';

    const strefa = document.createElement('div');
    strefa.className = 'neckle-dropzone';
    strefa.dataset.neckleDropzoneRoot = 'true';

    const opisId = 'neckle-dropzone-opis-' + Math.random().toString(36).slice(2, 8);

    strefa.innerHTML = `
      <button class="neckle-dropzone__trigger" type="button" aria-describedby="${opisId}">
        <span class="neckle-dropzone__ikona" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5"></path><path d="M5 14v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4"></path></svg>
        </span>
        <span class="neckle-dropzone__tresc">
          <strong>${tekst('dragPhoto', 'Przeciągnij zdjęcie pupila')}</strong>
          <span>${tekst('chooseFile', 'lub kliknij, żeby wybrać z dysku')}</span>
        </span>
      </button>
      <p class="neckle-dropzone__opis" id="${opisId}">${tekst('photoHelp', 'Najlepiej sprawdzi się ostre, dobrze oświetlone zdjęcie pyska (JPG, PNG lub HEIC, min. 1000×1000px). Jeśli nie nada się do grawerunku, odezwiemy się przed produkcją.')}</p>
      <div class="neckle-dropzone__podglad" hidden>
        <img class="neckle-dropzone__miniatura" alt="">
        <div class="neckle-dropzone__meta">
          <span class="neckle-dropzone__status" role="status">${tekst('photoAdded', 'Zdjęcie dodane ✓')}</span>
          <strong class="neckle-dropzone__nazwa"></strong>
          <span class="neckle-dropzone__szczegoly"></span>
          <p class="neckle-dropzone__ostrzezenie" hidden></p>
        </div>
        <button class="neckle-dropzone__zmien" type="button">${tekst('changePhoto', 'Zmień zdjęcie')}</button>
      </div>
      <p class="neckle-dropzone__blad" role="alert" hidden></p>
    `;

    input.parentNode.insertBefore(strefa, input);
    strefa.appendChild(input);
    input.classList.add('neckle-dropzone__input');
    // Ukryty input nie moze byc drugim, niewidocznym przystankiem w tabulacji -
    // rolę przycisku przejmuje trigger. Fokus programowy (np. walidacja
    // OwnPrint) nadal dziala przy tabindex="-1".
    input.setAttribute('tabindex', '-1');

    const trigger = strefa.querySelector('.neckle-dropzone__trigger');
    const podglad = strefa.querySelector('.neckle-dropzone__podglad');
    const miniatura = strefa.querySelector('.neckle-dropzone__miniatura');
    const nazwa = strefa.querySelector('.neckle-dropzone__nazwa');
    const szczegoly = strefa.querySelector('.neckle-dropzone__szczegoly');
    const ostrzezenie = strefa.querySelector('.neckle-dropzone__ostrzezenie');
    const blad = strefa.querySelector('.neckle-dropzone__blad');
    const zmien = strefa.querySelector('.neckle-dropzone__zmien');

    let aktywnyUrl = null;
    const zwolnijUrl = () => {
      if (aktywnyUrl) {
        URL.revokeObjectURL(aktywnyUrl);
        aktywnyUrl = null;
      }
    };

    const pokazBlad = (tekst) => {
      blad.textContent = tekst;
      blad.hidden = !tekst;
    };

    const wyczyscPodglad = () => {
      zwolnijUrl();
      podglad.hidden = true;
      podglad.classList.remove('is-visible');
      miniatura.removeAttribute('src');
      ostrzezenie.hidden = true;
      strefa.classList.remove('is-wypelniona');
    };

    const pokazPodglad = (plik) => {
      pokazBlad('');

      if (!plik.type.startsWith('image/')) {
        wyczyscPodglad();
        pokazBlad(tekst('notImage', 'To nie jest plik graficzny. Wybierz zdjęcie w formacie JPG, PNG lub HEIC.'));
        return;
      }

      zwolnijUrl();
      aktywnyUrl = URL.createObjectURL(plik);
      miniatura.src = aktywnyUrl;
      miniatura.alt = wstaw(
        tekst('previewAlt', 'Podgląd wgranego zdjęcia: __FILE__'),
        '__FILE__',
        plik.name,
      );
      nazwa.textContent = plik.name;
      szczegoly.textContent = formatujRozmiar(plik.size);
      podglad.hidden = false;
      podglad.classList.remove('is-visible');
      requestAnimationFrame(() => podglad.classList.add('is-visible'));
      strefa.classList.add('is-wypelniona');

      if (plik.size > MAX_PODGLAD_BAJTY) return;

      // Ostrzezenie o rozdzielczosci jest miekkie z rozmyslu. OwnPrint nie podal
      // twardego minimum px, wiec nie blokujemy zakupu - informujemy, bo to
      // najczestsza przyczyna nieudanego grawerunku.
      const sonda = new Image();
      sonda.onload = () => {
        const krawedz = Math.min(sonda.naturalWidth, sonda.naturalHeight);
        szczegoly.textContent = sonda.naturalWidth + ' × ' + sonda.naturalHeight + ' px · ' + formatujRozmiar(plik.size);
        if (krawedz && krawedz < MIN_KRAWEDZ_PX) {
          ostrzezenie.textContent = tekst(
            'smallPhoto',
            'To zdjęcie jest małe. Grawer może wyjść nieostry — jeśli masz wyraźniejsze, lepiej użyć tamtego.',
          );
          ostrzezenie.hidden = false;
        } else {
          ostrzezenie.hidden = true;
        }
      };
      sonda.onerror = () => { ostrzezenie.hidden = true; };
      sonda.src = aktywnyUrl;
    };

    const ustawPlik = (plik) => {
      const transfer = new DataTransfer();
      transfer.items.add(plik);
      input.files = transfer.files;
      // Handler OwnPrint slucha natywnego 'change' na swoim inpucie.
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    trigger.addEventListener('click', () => input.click());
    zmien.addEventListener('click', () => input.click());

    // Capture uruchamia podgląd przed bąbelkowaniem do OwnPrint. Aplikacja
    // może przebudować własne pole po wyborze pliku, ale nie może zatrzymać
    // naszej miniatury i jej animacji na tym samym zdarzeniu.
    input.addEventListener('change', () => {
      const plik = input.files && input.files[0];
      if (plik) pokazPodglad(plik);
      else wyczyscPodglad();
    }, true);

    ['dragenter', 'dragover'].forEach((nazwaZdarzenia) => {
      strefa.addEventListener(nazwaZdarzenia, (event) => {
        event.preventDefault();
        strefa.classList.add('is-nad');
      });
    });

    ['dragleave', 'dragend'].forEach((nazwaZdarzenia) => {
      strefa.addEventListener(nazwaZdarzenia, (event) => {
        if (nazwaZdarzenia === 'dragleave' && strefa.contains(event.relatedTarget)) return;
        strefa.classList.remove('is-nad');
      });
    });

    strefa.addEventListener('drop', (event) => {
      event.preventDefault();
      strefa.classList.remove('is-nad');
      const plik = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
      if (!plik) return;
      if (!plik.type.startsWith('image/')) {
        pokazBlad(tekst('notImage', 'To nie jest plik graficzny. Wybierz zdjęcie w formacie JPG, PNG lub HEIC.'));
        return;
      }
      ustawPlik(plik);
    });

    window.addEventListener('pagehide', zwolnijUrl);

    if (input.files && input.files.length) pokazPodglad(input.files[0]);
  };

  const skanuj = () => {
    slot.querySelectorAll('input[type="file"]').forEach(zbudujDropzone);
  };

  skanuj();

  // Aplikacja renderuje swoje pola asynchronicznie i potrafi je przebudowac
  // przy zmianie wariantu, wiec samo jednorazowe skanowanie nie wystarczy.
  new MutationObserver(skanuj).observe(slot, { childList: true, subtree: true });
})();
